var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 186,
    height: 91,
    viewBox: "0 0 186 91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#4b4b4b}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Print",
    transform: "translate(-1035 -644)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_822",
    fill: "none",
    d: "M0 0H186V91H0z",
    transform: "translate(1035 644)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_507",
    transform: "translate(-8959.566 -455)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_506"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_Printer",
    transform: "translate(10035.566 1129.22)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129",
    width: 2.856,
    height: 2.856,
    className: "cls-2",
    rx: 0.81,
    transform: "translate(39.98 16.573)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_130",
    width: 2.856,
    height: 2.856,
    className: "cls-2",
    rx: 0.81,
    transform: "translate(44.097 16.573)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_131",
    width: 24.58,
    height: 1.261,
    className: "cls-2",
    rx: 0.34,
    transform: "translate(15.4 34.864)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_132",
    width: 24.58,
    height: 1.261,
    className: "cls-2",
    rx: 0.34,
    transform: "translate(15.4 38.613)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_133",
    width: 24.58,
    height: 1.261,
    className: "cls-2",
    rx: 0.34,
    transform: "translate(15.4 31.115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    d: "M58.087 16.77H11.275A4.24 4.24 0 0 0 7 21.062v16.872a4.257 4.257 0 0 0 4.2 4.31h8.147v-1.577h-8.072a2.663 2.663 0 0 1-2.523-2.733V21.062a2.628 2.628 0 0 1 2.61-2.7h46.725a2.645 2.645 0 0 1 2.628 2.7v16.872a2.663 2.663 0 0 1-2.628 2.733H49.8v1.577h8.287a4.257 4.257 0 0 0 4.2-4.31V21.062a4.24 4.24 0 0 0-4.2-4.292z",
    className: "cls-2",
    transform: "translate(-7 -4.279)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    d: "M45.635 41.243H13.68V25.37h31.955zm-30.378-1.595h28.767V26.964H15.257z",
    className: "cls-2",
    transform: "translate(-1.977 2.188)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    d: "M45.145 22.131h-1.577V11.217H15.4v10.914h-1.58V9.64h31.325z",
    className: "cls-2",
    transform: "translate(-1.871 -9.64)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_502",
    transform: "translate(10186.959 573.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2434",
    d: "M-75.959 576.1v-15.155c0-1.076.469-1.56 1.51-1.56h17.139c1.123 0 2.247-.008 3.37.005a2.358 2.358 0 0 1 .816.126 1.2 1.2 0 0 1 .743 1.179c.02.677.009 1.354.009 2.031v21.25c0 1.088-.007 2.176 0 3.264a.942.942 0 0 1-.275.713c-1.493 1.544-2.977 3.1-4.479 4.631a.871.871 0 0 1-.57.223c-3.466.013-6.933.008-10.4.008h-6.384c-1 0-1.475-.481-1.476-1.526v-15.188zm22.465 10.719v-.43-25.308c0-.5 0-.5-.5-.5h-8.15q-6.145 0-12.29-.006c-.275 0-.341.1-.338.363.011 1.154 0 2.309 0 3.463q0 13.436-.009 26.872c0 .26.073.351.327.346.823-.015 1.647-.01 2.47-.01q6.739 0 13.477.007c.294 0 .386-.085.381-.392-.017-1-.014-2-.006-3a1.278 1.278 0 0 1 1.36-1.412h2.246zm-.883 1.2c-.842 0-1.629-.006-2.415.013-.059 0-.16.186-.162.287-.015.721-.01 1.443-.008 2.165a.682.682 0 0 0 .049.173z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2435",
    d: "M-14.662 615.031v15.153c0 1.033-.486 1.545-1.47 1.545h-20.377a5.686 5.686 0 0 1-.609-.021 1.212 1.212 0 0 1-1.124-1.2c-.03-.709-.018-1.421-.007-2.131a.572.572 0 0 1 .583-.58.559.559 0 0 1 .545.58c.013.588.02 1.177 0 1.765-.01.308.084.395.381.394q7.91-.014 15.821-.008c1.583 0 3.166-.007 4.749.006.28 0 .337-.1.336-.368q-.01-5.128-.005-10.256 0-6.743.005-13.487c0-2.187-.005-4.373.005-6.56 0-.3-.095-.383-.371-.373-.513.019-1.027.008-1.54 0-.479 0-.729-.215-.721-.6s.27-.585.742-.588h1.637a1.315 1.315 0 0 1 1.411 1.442q.008 4.046 0 8.092v7.193z",
    className: "cls-2",
    transform: "translate(-33.053 -34.121)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2436",
    d: "M-34.56 616.263h-6.9a1.046 1.046 0 0 1-.49-.1.519.519 0 0 1-.232-.633.56.56 0 0 1 .572-.443h13.86c.1 0 .193 0 .289.007a.61.61 0 0 1 .575.6.593.593 0 0 1-.619.58q-2.519.005-5.037 0h-2.018z",
    className: "cls-2",
    transform: "translate(-29.592 -48.828)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2437",
    d: "M-34.495 645.145h6.8a1.66 1.66 0 0 1 .414.034.542.542 0 0 1 .433.548.544.544 0 0 1-.406.57 1.511 1.511 0 0 1-.412.043h-13.7a1.857 1.857 0 0 1-.256-.009.577.577 0 0 1-.537-.625.568.568 0 0 1 .572-.555c.566-.016 1.133-.008 1.7-.008z",
    className: "cls-2",
    transform: "translate(-29.635 -75.189)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2438",
    d: "M-34.49 705.252h6.9a1.2 1.2 0 0 1 .318.026.545.545 0 0 1 .424.556.534.534 0 0 1-.411.563 1.754 1.754 0 0 1-.444.044h-13.6a1.471 1.471 0 0 1-.474-.054.54.54 0 0 1-.376-.589.523.523 0 0 1 .421-.518 1.6 1.6 0 0 1 .382-.031l6.86.003z",
    className: "cls-2",
    transform: "translate(-29.634 -127.889)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2439",
    d: "M-34.512 766.478h-6.767a1.713 1.713 0 0 1-.414-.03.534.534 0 0 1-.428-.547.529.529 0 0 1 .395-.571.96.96 0 0 1 .284-.04h13.951a.6.6 0 0 1 .648.428.57.57 0 0 1-.361.715 1.552 1.552 0 0 1-.443.05h-6.864z",
    className: "cls-2",
    transform: "translate(-29.666 -180.523)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2440",
    d: "M-38.039 676.35H-41.5a.582.582 0 0 1-.656-.529c-.03-.4.22-.651.67-.653 1.26-.005 2.521 0 3.781 0h3.108a.591.591 0 0 1 .662.6.589.589 0 0 1-.644.582h-3.461z",
    className: "cls-2",
    transform: "translate(-29.634 -101.51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2441",
    d: "M-38.026 735.38h3.5c.259 0 .5.093.552.357a.942.942 0 0 1-.106.61.58.58 0 0 1-.442.2q-3.513.019-7.026.007a.566.566 0 0 1-.588-.6.545.545 0 0 1 .585-.565c1.172-.013 2.351-.009 3.525-.009z",
    className: "cls-2",
    transform: "translate(-29.65 -154.303)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.5a938be8f91f183122e146122c3b79ad.svg";
export { ForwardRef as ReactComponent };